import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProgramView from "../views/ProgramView.vue"
import ContactView from "../views/ContactView.vue"
import AboutView from "../views/AboutView.vue"
import InterView from "../views/InterView.vue"
import ApplyView from "../views/ApplyView"
import ThankView from "../views/ThankView"
import ThankyoumbaView from "../views/ThankyoumbaView"
import landingView from "../views/landingView"
import SkillsView from "../views/SkillsView"
import BbafinanceView from "../views/BbafinanceView"
import BbahrmView from "../views/BbahrmView"
import BbamarketingView from "../views/BbamarketingView"
import BcacsView from "../views/BcacsView"
import BcadsaiView from "../views/BcadsaiView"
import ThankyouView from "../views/ThankyouView"
import PageNotFoundView from "../views/PageNotFoundView"
import BlogsView from "../views/BlogsView"
import BlogsListing from "../views/BlogsListing"
import BcaCyberView from "../views/BcaCyberView"
import AcademicView from "../views/AcademicView"
import DisclousersView from "../views/DisclousersView"
import EnrollmentView from "../views/EnrollmentView"
import BcaAnimationView from "../views/BcaAnimationView.vue"
import BbaHealth from '@/views/BbaHealth.vue'
import MbaDataScience from '@/views/MbaDataScience.vue'
import MbaFinance from '@/views/MbaFinance.vue'
import MbaFinanceHrm from '@/views/MbaFinanceHrm.vue'
import MbaHrm from '@/views/MbaHrm.vue'
import MbaInterna from '@/views/MbaInterna.vue'
import MbaMarkFin from '@/views/MbaMarkFin.vue'
import MbaMarketing from '@/views/MbaMarketing.vue'
import MbaMarktHrm from '@/views/MbaMarktHrm.vue'
import McaCs from '@/views/McaCs.vue'
import McaCloudCs from '@/views/McaCloudCs.vue'
import MbaHealth from '@/views/MbaHealth.vue'
import RefundView from '@/views/RefundView.vue'
import PrivacyPolicyView from '@/views/PrivacyPolicyView.vue'
import BcomAdvancedFinanceandAccountingView from "@/views/BcomAdvancedFinanceandAccountingView.vue"
import CorporateAccountingView from "../views/CorporateAccountingView.vue"
import ManagementAccountingView from "../views/ManagementAccountingView.vue"
import MbaStrategicAccountingandTaxation from "../views/MbaStrategicAccountingandTaxation.vue"
import MbaPublicAdmin from "../views/MbaPublicAdmin.vue"
const routes = [
  { path: '/:pathMatch(.*)*', 
  name: 'PageNotFound', 
  component: PageNotFoundView },

  { path: '/aboutus',
    redirect: '/about-us' },

  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/programs/online-bcom-accounting-and-finance',
    name: 'online-bcom-accounting-and-finance',
    component: ProgramView
  },
  {
    path: '/programs/online-bcom-corporate-accounting',
    name: 'online-bcom-corporate-accounting',
    component: CorporateAccountingView
  },
  {
    path: '/programs/online-bcom-management-accounting',
    name: 'online-bcom-management-accounting',
    component: ManagementAccountingView
  },
  {
    path: '/contactus',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/about-us',
    name: 'about',
    component: AboutView
  },
  {
    path: '/disclosures',
    name: 'Disclosures',
    component: DisclousersView
  },
  {
    path: '/academic-corner',
    name: 'Academic',
    component: AcademicView
  },
  {
    path: '/refund-policy',
    name: 'Refund-policy',
    component: RefundView
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicyView
  },
  {
    path: '/enrollment-data',
    name: 'Enrollment',
    component: EnrollmentView
  },
  {
    path: "/blogs/:blog/",
    name: "SelectedBlog",
    component: BlogsView,
    props:true
  },
  {
    path: "/blogs/",
    name: "Blogs",
    component: BlogsListing
  },
  {
    path: '/programs/online-bcom-international-finance-and-accounting',
    name: 'online-bcom-international-finance-and-accounting',
    component: InterView
  },
  {
    path: '/programs/online-bcom-advanced-finance-and-accounting',
    name: 'online-bcom-advanced-finance-and-accounting',
    component: BcomAdvancedFinanceandAccountingView
  },
 
  {
    path: '/programs/online-bba-finance',
    name: 'online-bba-finance',
    component: BbafinanceView,
    redirect: "/"
  },

  {
    path: '/programs/online-bba-general-management',
    name: 'online-bba-general-management',
    component: BbahrmView,
    
  },
  {
    path: '/programs/online-bba-logistics-and-supply-chain-management',
    name: 'online-bba-logistics-and-supply-chain-management',
    component: BbamarketingView,
    
  },

  // {
  //   path: '/programs/online-bba-marketing',
  //   name: 'online-bba-marketing',
  //   component: BbamarketingView,
  //   redirect: "/"
  // },

  {
    path: '/programs/online-bca-computer-science-and-it',
    name: 'online-bca-computer-science-and-it',
    component: BcacsView
  },
  {
    path: '/programs/online-bca-data-science-and-artificial-intelligence',
    name: 'online-bca-data-science-and-artificial-intelligence',
    component: BcadsaiView
  },
  {
    path: '/programs/online-bba-healthcare-management',
    name: 'online-bba-healthcare-management',
    component: BbaHealth
  },
 

  {
    path: '/apply',
    name: 'apply',
    component: ApplyView
  },

  {
    path: '/skills',
    name: 'skills',
    component: SkillsView
  },

  {
    path: '/brochure/bba-thankyou',
    name: 'bba-thankyou',
    component: ThankyouView
  },
  {
    path: '/brochure/MBA-thankyou',
    name: 'mba-thankyou',
    component: ThankyoumbaView
  },

  {
    path: '/brochure/bca-thankyou',
    name: 'bca-thankyou',
    component: ThankyouView
  },

  {
    path: '/brochure/bcom-thankyou',
    name: 'bcom-thankyou',
    component: ThankyouView
  },

  {
    path: '/lp/online-bachelors-degree',
    name: 'online-bachelors-degree',
    component: landingView
  },

  {
    path: '/lp/online-bachelors-degree/thankyou',
    name: 'thankyou',
    component: ThankView
  },

   // re-Direction

   {
    path: '/programs/online-bca-cloud-computing-and-cyber-security',
    name: 'online-bca-cloud-computing-and-cyber-security',
    component: BcaCyberView,
   
  },
  {
    path: '/programs/online-bca-animation-and-graphic-design',
    name: 'online-bca-animation-and-graphic-design',
    component: BcaAnimationView,
   
  },

  {
    path: '/programs/online-mba-marketing',
    name: 'online-mba-marketing',
    component: MbaMarketing,
   
  },
  {
    path: '/programs/online-mba-finance',
    name: 'online-mba-finance',
    component: MbaFinance,
   
  },
  {
    path: '/programs/online-mba-human-resource',
    name: 'online-mba-human-resource',
    component: MbaHrm,
   
  },
  {
    path: '/programs/online-mba-healthcare-management',
    name: 'online-mba-healthcare-management',
    component: MbaHealth,
   
  },
  {
    path: '/programs/online-mba-international-finance',
    name: 'online-mba-international-finance',
    component: MbaInterna,
   
  },
  {
    path: '/programs/online-mba-data-science-and-analytics',
    name: 'online-mba-data-science-and-analytics',
    component: MbaDataScience,
   
  },
  {
    path: '/programs/online-mba-marketing-and-finance',
    name: 'online-mba-marketing-and-finance',
    component: MbaMarkFin,
   
  },
  {
    path: '/programs/online-mba-marketing-and-human-resource',
    name: 'online-mba-marketing-and-human-resource',
    component: MbaMarktHrm,
   
  },
  {
    path: '/programs/online-mba-finance-and-human-resource',
    name: 'online-mba-finance-and-human-resource',
    component: MbaFinanceHrm,
   
  },
  {
    path: '/programs/online-mba-strategic-accounting-and-taxation',
    name: 'online-mba-strategic-accounting-and-taxation',
    component: MbaStrategicAccountingandTaxation,
   
  },
  {
    path: '/programs/online-mba-public-administration',
    name: 'online-mba-public-administration',
    component: MbaPublicAdmin,
  },
    

  {
    path: '/programs/online-mca-computer-science-and-it',
    name: 'online-mca-computer-science-and-it',
    component: McaCs,
  },

   {
    path: '/programs/online-mca-cloud-computing-and-cyber-security',
    name: 'online-mca-cloud-computing-and-cyber-security',
    component: McaCloudCs,
   
  },
  
];



 const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
   routes,
 });




export default router;
